import { render, staticRenderFns } from "./ConfirmPayFormUniversite.vue?vue&type=template&id=c6b25df2&"
import script from "./ConfirmPayFormUniversite.vue?vue&type=script&lang=js&"
export * from "./ConfirmPayFormUniversite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports